import "./form-waiver.scss";
import { useFormContext } from "react-hook-form";
import { WaiverFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";

type InputFormSchema = WaiverFormSchema;
export function FormWaiver() {
  const { control } = useFormContext<WaiverFormSchema>();
  return (
    <div id="FormWaiver" className="waiver">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="fontSize"
        label="Font Size"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter fontSize"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="subTitle"
        label="Sub Title"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter subTitle"
      />
    </div>
  );
}

export default FormWaiver;
